"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentAccessMethodType = void 0;
var ContentAccessMethodType;
(function (ContentAccessMethodType) {
    ContentAccessMethodType["FreePreview"] = "freePreview";
    ContentAccessMethodType["Mvpd"] = "mvpd";
    ContentAccessMethodType["InAppPurchase"] = "inAppPurchase";
    ContentAccessMethodType["Social"] = "social";
    ContentAccessMethodType["PartnerSubscription"] = "partnerSubscription";
})(ContentAccessMethodType = exports.ContentAccessMethodType || (exports.ContentAccessMethodType = {}));
